var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingConfig)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingConfig),expression:"loadingConfig"}],staticClass:"fullscreen-loading"}):_c('div',{attrs:{"id":"app"}},[_c('notifications'),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }